// Component to render the profile card
// Import react
import React, { useState, useEffect } from "react";

// Import supabase configuration
import supabase from "../../config/supabase";

// Import button
import Button from "../button/button";
import { Buffer } from "buffer";
import Skeleton from "react-loading-skeleton";
export default function Profile({
  data,
  filter = "",
  id = "",
  searched = false,
  onChange,
  checkProfile = "",
  searchedSkills = [],
  skillsAll,
}) {
  const [url, setUrl] = useState("/blurry.svg");
  const [skills, setSkills] = useState([]);
  const [missingSkills, setMissingSkills] = useState([]);
  const [skillArray, setSkillArray] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  useEffect(() => {
    setSkillArray(searchedSkills);
    missingSkillsFunc();
  }, [searchedSkills?.length]);

  useEffect(async () => {
    // var searched = localStorage.getItem('searchedItem') || "";
    // searched = searched && searched.split(':');
    // var temp = searched && (searched[1] && searched[1].split(','));

    // const lower = temp && temp.map(element => {
    // 	return element.toLowerCase().trim();
    //   });

    // searchedSkills.length && setSkillArray(searchedSkills);
    // if(searched){
    // 	searched[0] == "Skills" && setSkillArray({
    // 		filter : 'Skills',
    // 		list : lower
    // 	})
    // }

    missingSkillsFunc();

    // var profile = data;
    // // if dp is available
    // if (profile && profile.dp) {
    //   // get url for dp
    //   const { signedUrl, data, error } = await supabase.storage
    //     .from("data")
    //     .createSignedUrl(profile.dp, 600);

    //   if (data) {
    //     // set url
    //     setUrl(data["signedURL"]);
    //     setShowLoader(false);
    //   }
    // }
  }, [data]);

  const missingSkillsFunc = () => {
    var primarySkills = [];
    primarySkills =
      data &&
      data.skill_level.length > 0 &&
      data.skill_level.map((element) => {
        return element.skill.toLowerCase().trim();
      });

    // Set skills
    setSkills(primarySkills);

    var missing_skills = [];
    var check = false;
    searchedSkills = searchedSkills.map((s) => s?.toLowerCase());
    if (searchedSkills.length) {
      for (var i = 0; i < searchedSkills.length; i++) {
        check = false;
        // Run loop on user skills
        for (var k = 0; k < primarySkills.length; k++) {
          if (
            primarySkills[k].includes(searchedSkills[i]) ||
            searchedSkills[i].split(" ").includes(primarySkills[k]) ||
            searchedSkills[i].split(".").includes(primarySkills[k]) ||
            searchedSkills[i]
              .split(".")
              .includes(primarySkills[k].split(" ")[0]) ||
            searchedSkills[i]
              .split(".")
              .includes(primarySkills[k].split(".")[0])
          ) {
            check = true;
          }
        }
        if (!check) {
          missing_skills.push(searchedSkills[i]);
        }
      }

      setMissingSkills(missing_skills);
    }
  };

  const onHandleChange = (e) => {
    // Pass state to parent if handler provided
    if (onChange) {
      // Pass data
      onChange(data.id, checkProfile);
    }
  };

  const viewProfile = () => {
    window.open(
      `${window.location.origin}/profile?id=${Buffer.from(
        data.id,
        "utf8"
      ).toString("base64")} `,
      "_blank"
    );
  };

  return (
    <>
    {/* show Loader on condition*/}
      {showLoader && (
        <div className="fixed flex items-center justify-center z-10 w-full h-full top-0">
          {/* Add backdrop */}
          
          <div className={`absolute opacity-20 bg-black-1 w-full h-full`}></div>
          <div className={`relative `}>
            <img src="/loader.png"  className="rotate"/>
          </div>
        </div>
      )} 
    {/* // Function to render the content */}
    <div className="w-full h-auto relative mb-10">

      {/* Add card */}
      <div className="rounded-2xl bg-white-1 shadow-clientCard h-auto grid grid-cols-12 gap-3 p-6 box-border">
        {searched && (
          <div className="col-span-12">
            {/* Add an input */}
            <input
              type="checkbox"
              checked={data.checked}
              id={data.id}
              className="w-5 h-5"
              onChange={onHandleChange}
            />
          </div>
        )}

        {/* Column for avatar and checkbox */}
        
         
        
          <div className="col-span-12 sm:col-span-3 lg:col-span-2 flex items-center relative">
          {/* Render image if provided */}
          {data.image_url ? (
            // Render imgae
            <img className="object-cover w-20 h-20" src={data.image_url} />
          ) : (
            // Render placeholder
            <div className="w-20 h-20 bg-white-3 flex items-center">
              {/* Render text */}
              <div className="text-center w-full text-md font-text text-white-1 font-medium">
                {data.full_name && data.full_name[0].toUpperCase()}
              </div>
            </div>
          )}
        </div>
       
        

        {/* Column for details */}
        <div className="col-span-12 sm:col-span-9 lg:col-span-10 grid grid-cols-12 gap-3">
          {/* Column for name and email*/}
          <div className="col-span-12">
            {/* Render name */}
            <div className="w-full text-lg font-text text-black-1 font-normal">
              {data.full_name}
            </div>

            {/* Render email */}
            {data.email ? (
              <div
                className={`${
                  filter == "email" && "font-bold"
                } w-full mb-2 text-xs font-text text-black-2 flex items-center`}
              >
                {/* Icon */}
                <svg
                  className="h-3 w-3 fill-current text-black-1 mr-2"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm17 4.238l-7.928 7.1L4 7.216V19h16V7.238zM4.511 5l7.55 6.662L19.502 5H4.511z" />
                </svg>

                {/* Text */}
                {data.email}
              </div>
            ) : null}

            {/* Render gaper id */}
            {/* {data.serial_no ? (
              <div
                className={`${
                  filter == "gaper_id" && "font-bold"
                } w-full mb-2 text-xs font-text text-black-1 flex items-center`}
              >
                {/* Icon 
                <svg
                  className="h-3 w-3 fill-current text-black-1 mr-2"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path d="M9 18H4v-8h5v8zm6 0h-5V6h5v12zm6 0h-5V2h5v16zm1 4H3v-2h19v2z" />
                </svg>

                {/* Text 
                {data.serial_no}
              </div>
            ) : null} */}

            {/* Render phone */}
            {data.phone ? (
              <div className="w-full mb-2 text-xs font-text text-black-1 flex items-center">
                {/* Icon */}
                <svg
                  className="h-3 w-3 fill-current text-black-1 mr-2"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path d="M9.366 10.682a10.556 10.556 0 0 0 3.952 3.952l.884-1.238a1 1 0 0 1 1.294-.296 11.422 11.422 0 0 0 4.583 1.364 1 1 0 0 1 .921.997v4.462a1 1 0 0 1-.898.995c-.53.055-1.064.082-1.602.082C9.94 21 3 14.06 3 5.5c0-.538.027-1.072.082-1.602A1 1 0 0 1 4.077 3h4.462a1 1 0 0 1 .997.921A11.422 11.422 0 0 0 10.9 8.504a1 1 0 0 1-.296 1.294l-1.238.884zm-2.522-.657l1.9-1.357A13.41 13.41 0 0 1 7.647 5H5.01c-.006.166-.009.333-.009.5C5 12.956 11.044 19 18.5 19c.167 0 .334-.003.5-.01v-2.637a13.41 13.41 0 0 1-3.668-1.097l-1.357 1.9a12.442 12.442 0 0 1-1.588-.75l-.058-.033a12.556 12.556 0 0 1-4.702-4.702l-.033-.058a12.442 12.442 0 0 1-.75-1.588z" />
                </svg>

                {/* Text */}
                {data.phone}
              </div>
            ) : null}
          </div>

          {/* Column for location and exp */}
          <div className="col-span-12 lg:col-span-5">
            {/* Render location */}
            {data.location ? (
              <div className="w-full mb-4 text-sm font-light text-black-1 flex items-center">
                {/* Icon */}
                <img className="mr-1 h-4 " src="/location.png" alt="Avatar" />

                {/* Text */}
                {data.location} 
              </div>
            ) : null}

            {/* Render exp */}
            {data.exp ? (
              <div className="w-full mb-2 text-xs font-normal text-black-2">
                <div>EXPERIENCE</div>
                <div className="text-black-1 text-sm">
                  {/* Text */}
                  {data.exp} Years
                </div>
              </div>
            ) : null}
          </div>

          {/* Column for experience and contract */}
          <div className="col-span-12 lg:col-span-4">
            {/* Render exp */}
            {data.timezone ? <div className="text-sm font-light flex mb-4" >
                <svg className="mt-0.5 h-4 w-4 fill-current text-black-1 mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm1-8h4v2h-6V7h2v5z"/></svg>
                {data.timezone.split(" ")[0].replace(/[\(\)]/g, "")}
              </div>
             : null}

            {/* Render expected_hourly_rate */}
            {data.expected_hourly_rate ? (
              <div className="w-full mb-2 text-sm font-semibold text-black-1">
                <div className="text-black-2 text-xs font-normal"> HOURLY RATE</div>
                {/* Text */}
                <div>{data.expected_hourly_rate}$</div>
              </div>
            ) : null}
          </div>

          {/* Column for view profile and view linkedin */}
          <div className="hidden md:block col-span-3">
            {/* Render button for view profile */}
            <Button
              value="View Profile"
              type="button"
              buttonType="primary"
              className="mb-2"
              onClick={() => viewProfile()}
            />

            {/* Button for View linkedin */}
            {/* { 
              data.linkedin_link ? <Button value="Open Linkedin" type="button" buttonType="secondary" className="w-full py-1.5" onClick={() => viewLinkedin()}/> : null 
            } */}
          </div>
        </div>

        {/* Add space */}
        <div className="hidden md:block col-span-2"></div>

        {/* Show skills */}
        <div className="col-span-12 md:col-span-10 flex flex-wrap">
          {/* Render tags */}
          {skills
            ? skills.map((skill, index) => (
                <div
                  key={index}
                  className={`${
                    skillArray.length
                      ? skillArray
                          ?.toString()
                          .toLowerCase()
                          .includes(skill.split(" ")[0]?.toLowerCase()) ||
                        skillArray
                          ?.toString()
                          .toLowerCase()
                          .includes(skill.split(".")[0]?.toLowerCase())
                        ? "bg-blue-7"
                        : "bg-white-1"
                      : "bg-white-1"
                  } text-black-1 text-sm p-1 mr-2 mb-2 rounded-sm border-blue-7 bg-white-1 border-2 font-text whitespace-nowrap`}
                >
                   {skillArray.length
                      ? (skillArray
                          ?.toString()
                          .toLowerCase()
                          .includes(skill.split(" ")[0]?.toLowerCase()) ||
                        skillArray
                          ?.toString()
                          .toLowerCase()
                          .includes(skill.split(".")[0]?.toLowerCase())
                        ? <span className="flex flex-center">
                          <svg className="mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 17l-5.878 3.59 1.598-6.7-5.23-4.48 6.865-.55L12 2.5l2.645 6.36 6.866.55-5.231 4.48 1.598 6.7z" fill="rgba(32,78,207,1)"/></svg>
                         { skill }</span>
                        : skill )
                        : skill
                      
                  }
                </div>
              ))
            : null}
        </div>

        {/* Show missing skill */}
        {searched && missingSkills.length > 0 && (
          <div className="col-span-12 md:col-span-10 flex flex-wrap">
            Missing:
            {/* Render tags */}
            {missingSkills.map((skill, index) => (
              <div
                key={index}
                className={`text-black-1 text-xs p-0.5 ml-2 mt-1 line-through `}
              >
                {skill}
              </div>
            ))}
          </div>
        )}

        {/* Column for view profile and view linkedin */}
        <div className="block md:hidden col-span-12">
          {/* Render button for view profile */}
          <Button
            value="View Profile"
            buttonType="primary"
            className="mb-2"
            onClick={() => viewProfile()}
          />

          {/* Button for View linkedin */}
          {/* { 
						data.linkedin_link ? <Button value="Open Linkedin" type="button" buttonType="secondary" className="w-full py-1.5" onClick={() => viewLinkedin()}/> : null
					} */}
        </div>
      </div>
    </div>
    </>
  );
}
